export const CommonConstants = {
    // used by create curation page or edit curation page
    CurationRecommendedTicketTypeId: "RecommendedCreateTasks",
    CurationTicketTypeId: "CreateTasks"
}